import { render, staticRenderFns } from "./compliance.vue?vue&type=template&id=6005504a"
import script from "./compliance.vue?vue&type=script&lang=js"
export * from "./compliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6005504a')) {
      api.createRecord('6005504a', component.options)
    } else {
      api.reload('6005504a', component.options)
    }
    module.hot.accept("./compliance.vue?vue&type=template&id=6005504a", function () {
      api.rerender('6005504a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/compliance.vue"
export default component.exports